import { render, staticRenderFns } from "./hdpItemMore.vue?vue&type=template&id=72d359c4&lang=pug&"
import script from "./hdpItemMore.vue?vue&type=script&lang=js&"
export * from "./hdpItemMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports